import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const faqs = [
  {
    question: "What is Study Partners?",
    answer:
      "Study Partners is a student-focused learning platform designed to help learners study together, share knowledge, and improve understanding through collaboration.",
  },
  {
    question: "Who can use Study Partners?",
    answer:
      "Study Partners can be used by school students (from Class 9 onwards), college students, and learners preparing for academic or competitive exams.",
  },
  {
    question: "How does group study help in learning?",
    answer:
      "Group study helps students understand concepts better through discussion, idea sharing, and peer support, making learning more effective and engaging.",
  },
  {
    question: "Can I find study partners with similar goals?",
    answer:
      "Yes. Study Partners helps you connect with learners who share similar academic goals, subjects, and study interests.",
  },
  {
    question: "Is Study Partners safe to use?",
    answer:
      "Yes. Study Partners follows strong security practices to protect user data and ensure a safe learning environment.",
  },
  {
    question: "Can I use Study Partners for exam preparation?",
    answer:
      "Absolutely. The platform is suitable for board exams, college exams, and various competitive exam preparations.",
  },

  {
    question: "Can I chat with my study partners?",
    answer:
      "Yes. You can communicate with your study partners to discuss topics, clear doubts, and stay motivated during your study sessions.",
  },
  {
    question: "Is there any registration fee?",
    answer:
      "No. Registration on Study Partners is completely free for students.",
  },
  {
    question: "How can I contact Study Partners support?",
    answer:
      "You can reach out to Study Partners support through the help or support section available on the platform.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      id="faq"
      className="bg-[#C8F1F9] py-20 px-4 sm:px-10 lg:px-24"
    >
      <h2 className="text-4xl font-extrabold text-center text-[#3498db] mb-14">
        Frequently Asked Questions
      </h2>

      <div className="max-w-4xl mx-auto space-y-6">
        {faqs.map((item, index) => (
          <div
            key={index}
            onClick={() => toggleIndex(index)}
            className="
              bg-white rounded-2xl shadow-lg
              p-6 cursor-pointer
              border border-gray-100
              transition-all duration-300
              hover:shadow-xl
            "
          >
            <div className="flex justify-between items-center">
              <h3 className="text-lg md:text-xl font-semibold text-gray-800">
                {item.question}
              </h3>
              {openIndex === index ? (
                <ChevronUp className="text-[#3498db]" />
              ) : (
                <ChevronDown className="text-[#3498db]" />
              )}
            </div>

            {openIndex === index && (
              <p className="mt-4 text-gray-600 leading-relaxed">
                {item.answer}
              </p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
